<template>
  <main @keydown.esc="closeAboutModal">
    <section class="relative flex center overflow-hidden">
      <base-picture
        v-if="hero.smPic"
        v-bind="hero.smPic"
        :alt="hero.alt"
        class="animate-$animate md:hidden"
        :props-img="{
          style: 'max-width: none;',
        }"
        style="width:238vw; height: 141vw; --animate: vf-pan-x 10s ease-in-out infinite alternate"
      />
      <base-picture
        v-if="hero.mdPic"
        v-bind="hero.mdPic"
        :alt="hero.alt"
        class="animate-$animate <md:hidden"
        :props-img="{
          style: 'height: 43vw;',
        }"
        style="width: 100vw; height: 40vw; --animate: vf-zoomPulse 10s ease-in-out infinite alternate"
      />
      <div class="vf-10eby9">
        <h1 class="w-full display-2 md:mb-10 lg:display-3">
          {{ hero.title }}
        </h1>
        <p class="md:text-md" style="margin-bottom: 3.75rem">
          {{ hero.desc }}
        </p>
      </div>
      <span
        v-for="i in [43, 0]"
        :key="i"
        class="absolute bottom-0 mb-5 h-10 w-10 flex center rounded-full bg-white"
        :class="i === 0 ? '<md:hidden' : 'md:hidden'"
      >
        <base-button
          :aria-label="$t.scrollToNextSection"
          @click="handleDownwardNav('our-roots', i)"
        >
          <vf-icon
            class="c-black"
            name="arrow"
            size="md"
            style="animation: vf-arrow-animation 2.5s linear infinite"
          />
        </base-button>
      </span>
    </section>
    <cms-section v-if="eSpots?.[0]" :section="eSpots[0]" />
    <section class="sticky z-2 b-grey-80 bg-white <md:b-y" style="top: 3.6875rem">
      <nav
        :aria-label="stickyNav.label"
        class="overflow-x-auto overflow-y-hidden ws-nowrap px-2 py-3 scrollbar-none md:hidden"
      >
        <a
          v-for="({ id, text }, i) in stickyNav.sections"
          :key="i"
          class="mx-1 px-3 py-1 text-sm uppercase"
          :class="{ 'bg-brand-2 c-white rounded-full duration-1000': i === activeLink }"
          :href="`#${id}`"
          @click.prevent="handleTabNav(id, i)"
        >
          {{ text }}
        </a>
      </nav>
    </section>

    <section id="our-roots" class="relative bg-white" :class="{ 'z-50': atOurRoots }" data-scroll-el="our-roots">
      <div class="sticky right-0 z-1 h-full" style="top: 3.75rem">
        <vf-button
          v-if="atOurRoots"
          :aria-label="readLess"
          class="absolute right-0 z-1 mr-4 mt-10 p-4"
          @click="handleOurRoots"
        >
          <vf-icon name="close" size="md" />
        </vf-button>
      </div>
      <div class="relative wrap md:flex">
        <div class="md:w-1/2 md:flex md:center">
          <div class="center md:max-w-2/3 <md:f-col <md:overflow-x-hidden">
            <base-picture
              v-bind="ourRoots.picture"
              class="md:hidden"
              :class="atOurRoots ? 'animate-rotate-width-in' : 'animate-rotate-width-out'"
              style="order: 1"
            />
            <h2
              class="z-1 display-2 <md:m-4 md:mb-24 md:mt-10 lg:display-3"
              :class="atOurRoots ? 'self-start' : '<md:c-white <md:absolute <md:top-0 <md:mt-4'"
            >
              {{ ourRoots.title }}
            </h2>
            <h3 class="mb-8 title-2 <md:hidden">
              {{ ourRoots.subtitle }}
            </h3>
            <p class="mb-12 text-md <md:hidden">
              {{ ourRoots.description }}
            </p>
            <vf-button
              v-show="!atOurRoots"
              class="bottom-0 z-1 mb-4 <md:absolute md:mb-10"
              :class="{ '<md:hidden': atOurRoots }"
              :size="{ sm: 'xs', md: 'sm' }"
              :variant="{ sm: 'primary-inverse', md: 'primary' }"
              @click="handleOurRoots"
            >
              {{ discoverMore }}
              <vf-icon class="ml-4 md:c-white" :name="atOurRoots ? 'minus' : 'plus'" />
            </vf-button>
          </div>
        </div>
        <base-picture
          v-bind="ourRoots.picture"
          class="w-1/2 <md:hidden"
          :class="atOurRoots ? 'animate-rotate-scale-in' : 'animate-rotate-scale-out'"
        />
        <div v-if="atOurRoots" class="w-full <md:hidden" style="margin-top: -5rem">
          <span class="mx-a h-10 w-10 flex center rounded-full bg-black">
            <base-button @click="handleDownwardNav('our-roots-video', 0)">
              <vf-icon
                class="c-white"
                name="arrow"
                size="md"
                style="animation: vf-arrow-animation 2.5s linear infinite"
              />
            </base-button>
          </span>
        </div>
      </div>

      <base-collapse v-model="atOurRoots" :class="{ 'h-0': !atOurRoots }" class-content="f-col center transition-none">
        <h3 id="our-roots-title" class="mb-8 w-full title-2 container md:hidden">
          {{ ourRoots.subtitle }}
        </h3>
        <p class="mb-12 text-md container md:hidden">
          {{ ourRoots.description }}
        </p>
        <div class="relative flex center" data-scroll-el="our-roots-video">
          <base-picture v-bind="ourRoots.outdoors.picture" class="<md:hidden" />
          <div class="f-col center md:absolute">
            <vf-video v-bind="ourRoots.outdoors.video" aria-labelledby="our-roots-title" class="<md:mb-12" loop />
            <base-button
              class="absolute f-col center c-white"
              @click="ModalYoutube.open(
                {
                  videoUrl: ourRoots.outdoors.youtube,
                  title: ourRoots.subtitle,
                },
              )"
            >
              <span class="mb-4 b-2 b-white rounded-full p-2">
                <vf-icon name="play" size="2xl" />
              </span>
              <span class="title-3">{{ playVideo }}</span>
            </base-button>
          </div>
        </div>

        <template v-for="({ title, description, picture, video, youtube }, i) in ourRoots.sections" :key="i">
          <div v-if="i === 1" class="w-full overflow-y-hidden <md:mb-8 md:-mb-20" style="max-height:36rem">
            <h3 class="my-4 text-center display-3 md:hidden">
              {{ title }}
            </h3>
            <base-picture v-bind="ourRoots.factory" class="w-full md:-mt-20" />
          </div>
          <div class="full center <md:mb-8 md:flex" :class="{ '<md:f-col': i === 1 }">
            <div class="f-col center md:w-1/2" :style="{ order: i % 2 ? '' : 1 }">
              <h3 v-if="i !== 1" v-html="title" class="my-4 display-3 container md:hidden" />
              <base-picture v-if="picture" v-bind="picture" class="<md:mb-8" />
              <vf-video v-if="video" v-bind="video" :aria-label="title" :class="{ '<md:mb-8': i === 1 }" loop />
              <base-button
                v-if="i === 1"
                class="absolute f-col center c-white"
                @click="ModalYoutube.open(
                  {
                    videoUrl: youtube,
                    title,
                  },
                )"
              >
                <span class="mb-4 b-2 b-white rounded-full p-2">
                  <vf-icon name="play" size="2xl" />
                </span>
                <span class="title-3">{{ playVideo }}</span>
              </base-button>
            </div>
            <div class="md:w-1/2" :class="{ '<md:order-first': i === 1 }">
              <h3 v-html="title" class="my-4 max-w-2/3 pb-10 display-3 container <md:hidden" />
              <p v-html="description" class="text-md container md:max-w-2/3" :class="{ '<md:mb-8': i === 1 }" />
            </div>
          </div>
        </template>

        <vf-button class="mb-4 md:mb-10" :size="{ sm: 'xs', md: 'sm' }" @click="handleOurRoots">
          {{ readLess }}
          <vf-icon class="ml-4 c-white" :name="atOurRoots ? 'minus' : 'plus'" />
        </vf-button>
      </base-collapse>
    </section>
    <cms-section v-if="eSpots?.[1]" :section="eSpots[1]" />
    <section id="culture-of-innovation" class="relative" data-scroll-el="culture-of-innovation">
      <div class="bg-brand-5 md:flex">
        <vf-video v-bind="cultureOfInnovation.video" aria-labelledby="culture-of-innovation-title" class="w-1/2 <md:hidden" loop />
        <div class="md:w-1/2 md:flex md:center <md:p-6">
          <div class="md:max-w-2/3">
            <h2 id="culture-of-innovation-title" class="display-2 md:mb-10 lg:display-3">
              {{ cultureOfInnovation.title }}
            </h2>
            <vf-video v-bind="cultureOfInnovation.video" aria-labelledby="culture-of-innovation-title" class="md:hidden" loop />
            <p class="md:pb-10 md:text-md">
              {{ cultureOfInnovation.description }}
            </p>
            <base-button
              class="mx-a w-full flex center items-center justify-end pb-12 pt-8 uppercase md:hidden"
              @click="openAboutModal('culture-of-innovation-mobile', 'culture-of-innovation')"
            >
              {{ cultureOfInnovation.arrowDescription }}
              <span class="ml-4 h-10 w-10 flex center rounded-full bg-black" style="transform:rotate(270deg)">
                <vf-icon class="c-white" name="arrow" size="md" style="animation: vf-arrow-animation 2.5s linear infinite" />
              </span>
            </base-button>
            <base-button
              class="flex items-center uppercase <md:hidden"
              @click="openAboutModal('culture-of-innovation-desktop', 'culture-of-innovation')"
            >
              {{ cultureOfInnovation.arrowDescription }}
              <span class="ml-4 h-10 w-10 flex center rounded-full bg-black" style="transform:rotate(270deg)">
                <vf-icon class="c-white" name="arrow" size="md" style="animation: vf-arrow-animation 2.5s linear infinite" />
              </span>
            </base-button>
          </div>
        </div>
      </div>

      <modal-about-us
        v-if="target === 'culture-of-innovation-mobile'"
        class="bg-white"
        class-button-next="right-0 top-1/2 absolute <md:hidden"
        class-button-previous="right-0 top-1/2 absolute <md:hidden"
        @close="closeAboutModal"
      >
        <template v-for="slide in cultureOfInnovation.slides" :key="slide.id">
          <div
            v-for="({ title, description, picture, video, features, text, cta }, i) in slide.content"
            :key="i"
            class="relative full f-col"
            :class="[{ between: slide.id === 2 }, slide.background]"
          >
            <div class="f-col items-center" style="height: 100vh">
              <div :class="{ 'mt-5': slide.id === 1 }">
                <base-picture
                  v-if="picture"
                  v-bind="picture"
                  :props-img="{ class: 'max-h-full contain' }"
                />
                <vf-video v-else-if="video" v-bind="video.sm" :aria-label="title" class="max-h-full" loop />
              </div>

              <vf-video
                v-if="slide.id === 2"
                v-bind="slide.content[0].video.sm"
                :aria-label="title"
                class="absolute full cover"
                loop
                style="filter: brightness(50%)"
              />
              <div v-if="features" class="absolute full f-col center px-5 c-white">
                <div
                  v-for="(feature, j) in features"
                  :key="j"
                  class="grid cols-2 items-center gap-3 b-b b-white py-3 text-sm"
                >
                  <div :class="j % 2 ? 'w-1/3' : 'w-3/4'">
                    <base-picture v-bind="feature.picture" />
                  </div>
                  <p>
                    {{ feature.description }}
                  </p>
                </div>
              </div>
              <div
                v-else
                class="px-6"
                :class="{
                  'absolute full f-col between py-12': slide.id === 2,
                  'pt-8': slide.id === 4,
                  'pt-6': slide.id !== 2 && slide.id !== 4,
                }"
              >
                <template v-if="slide.id === 2">
                  <h2 class="title-4 c-white">
                    {{ title }}
                  </h2>
                  <div class="pr-10">
                    <p
                      v-for="(item, j) in description"
                      :key="j"
                      v-html="item.text"
                      class="mb-4 text-sm title-4 c-white"
                    />
                  </div>
                </template>
                <template v-else>
                  <h2 v-html="title" class="pb-4 title-4" />
                  <p v-html="description" />
                </template>
                <template v-if="text">
                  <div v-for="({ subtitle, desc }, j) in text" :key="j" class="pb-7">
                    <h3 v-html="subtitle" class="pb-4 title-4" />
                    <p v-html="desc" />
                  </div>
                  <vf-button class="w-full text-center" size="xs" :to="cta.url">
                    {{ cta.text }}
                  </vf-button>
                </template>
              </div>
            </div>
          </div>
        </template>
      </modal-about-us>

      <modal-about-us
        v-if="target === 'culture-of-innovation-desktop'"
        class="bg-white"
        class-button-next="right-0 top-1/2 absolute <md:hidden"
        class-button-previous="right-0 top-1/2 absolute <md:hidden"
        :title="cultureOfInnovation.titleShorthand"
        @close="closeAboutModal"
      >
        <template #default="{ active }">
          <div
            v-for="({ id, background, content }, j) in cultureOfInnovation.slides"
            :key="id"
            class="relative full flex center overflow-hidden"
            :class="background"
            :inert="j !== active"
          >
            <vf-video
              v-if="id === 2"
              v-bind="content[0].video.md"
              class="full cover o:absolute"
              loop
              style="filter: brightness(50%)"
            />
            <template v-if="id === 3">
              <div
                v-for="({ title, description, picture }, key) in content"
                :key
                class="flex"
              >
                <div class="w-1/2">
                  <base-picture v-if="picture" v-bind="picture" :props-img="{ class: 'cover' }" style="height: 100vh" />
                </div>
                <div class="w-1/2 flex center px-20">
                  <div class="w-3/4">
                    <h2 v-html="title" class="pb-6 title-2" />
                    <p v-html="description" class="text-md" />
                  </div>
                </div>
              </div>
            </template>

            <template v-else>
              <div
                v-for="{ title, description, picture, video, features, text, cta } in content"
                :key="title"
                :aria-label="title"
                class="relative f-col center"
                style="height: 80%"
              >
                <div>
                  <base-picture v-if="picture" v-bind="picture" :props-img="{ class: 'max-h-full contain' }" />
                  <vf-video v-if="video && id !== 2" v-bind="video.md" :aria-label="title" class="max-h-full" loop />
                </div>
                <div v-if="features" class="px-20 c-white">
                  <div
                    v-for="(feature, y) in features"
                    :key="y"
                    class="grid cols-2 items-center gap-3 b-b b-white py-5"
                  >
                    <base-picture v-bind="feature.picture" :class="y % 2 ? 'w-1/3' : 'w-3/4'" />
                    <p class="text-md">
                      {{ feature.description }}
                    </p>
                  </div>
                </div>

                <div v-else class="px-20">
                  <template v-if="id === 2">
                    <p
                      v-for="(item, key) in description"
                      :key
                      v-html="item.text"
                      class="mb-10 title-2 c-white"
                    />
                  </template>

                  <template v-else>
                    <h2 v-if="id !== 4" v-html="title" class="pb-6 title-2" />
                    <p v-html="description" class="text-md" />
                  </template>

                  <template v-if="text">
                    <div v-for="{ subtitle, desc } in text" :key="subtitle" class="pb-16">
                      <h3 v-html="subtitle" class="pb-2 title-2" />
                      <p v-html="desc" class="pb-6 text-md" />
                    </div>

                    <vf-button class="w-full text-center" size="xs" :to="cta.url">
                      {{ cta.text }}
                    </vf-button>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </template>
      </modal-about-us>
    </section>
    <cms-section v-if="eSpots?.[2]" :section="eSpots[2]" />
    <section
      ref="iconsRef"
      id="icons"
      class="relative flex center bg-black py-8"
      :class="{ 'overflow-hidden': !target }"
      data-scroll-el="icons"
    >
      <transition enter-active-class="animate-slide-fade-in" leave-active-class="op-0">
        <p
          v-if="isIconsVisible"
          aria-hidden="true"
          class="absolute top-0 text-center fw-bold font-secondary uppercase container <md:hidden"
          style="font-size: 10rem"
        >
          {{ icons.backgroundText }}<sup>&reg;</sup><br>
          {{ icons.backgroundText }}<sup>&reg;</sup><br>
          {{ icons.backgroundText }}<sup>&reg;</sup>
        </p>
      </transition>
      <div class="z-1 grid container md:mb-20 md:mt-10 <md:gap-y-8">
        <h2 class="text-center display-3 c-white md:mt-6">
          {{ icons.title }}
        </h2>
        <div class="grid gap-8 md:cols-3 md:mt-12 md:gap-6">
          <div
            v-for="({ number, description, id, video }, i) in icons.boots"
            :key="i"
            :id
            class="relative rounded-lg rounded-lg bg-white pb-3 pt-10 <md:hidden"
            :class="isIconsVisible ? { 'animate-slide-fade-in': i === 1, 'animate-slide-fade-in-delay': i !== 1 } : ''"
            data-test-id="article-card-md"
          >
            <vf-video v-bind="video" aria-hidden="true" class="aspect-square" loop />
            <p v-html="description" :id="`icons-description-desktop-${number}`" class="absolute w-3/5 title-2" style="top: 1.5rem; left: 1.5rem" />
            <div class="absolute flex items-center gap-3" style="bottom: 1.5rem; right: 3rem">
              <span :id="`icons-action-desktop-${number}`" class="mono text-sm">{{ discoverMore }}</span>
              <span class="h-10 w-10 flex center rounded-full bg-black c-white" style="transform:rotate(270deg)">
                <vf-icon
                  dir="right"
                  name="arrow"
                  size="md"
                  style="animation: vf-arrow-animation 2.5s linear infinite"
                />
              </span>
            </div>
            <base-button :aria-labelledby="`icons-action-desktop-${number} icons-description-desktop-${number}`" class="absolute-0" @click="openAboutModal(`icons-${number}`, 'icons')" />
          </div>
          <div
            v-for="({ number, description, video }, i) in icons.boots"
            :key="i"
            class="relative rounded-lg rounded-lg bg-white pb-3 pt-10 md:hidden"
            data-test-id="article-card-sm"
          >
            <vf-video v-bind="video" aria-hidden="true" class="aspect-square" loop />
            <p v-html="description" :id="`icons-description-mobile-${number}`" class="absolute w-3/5 title-1" style="top: 1.5rem; left: 1.5rem" />
            <div class="absolute flex items-center gap-3" style="bottom: 1.5rem; right: 3rem">
              <span :id="`icons-action-mobile-${number}`" class="mono text-sm">{{ discoverMore }}</span>
              <span class="h-11 w-11 flex center rounded-full bg-black c-white" style="transform:rotate(270deg)">
                <vf-icon
                  dir="right"
                  name="arrow"
                  size="md"
                  style="animation: vf-arrow-animation 2.5s linear infinite"
                />
              </span>
            </div>
            <base-button :aria-labelledby="`icons-action-mobile-${number} icons-description-mobile-${number}`" class="absolute-0" @click="openAboutModal(`icons-${number}`, 'icons')" />
          </div>
        </div>
      </div>

      <modal-about-us
        v-if="target === 'icons-01'"
        class="bg-white"
        class-button-next="right-0 md:top-1/2 absolute <md:bottom-0 <md:mb-14"
        class-button-previous="md:right-0 md:top-1/2 absolute <md:bottom-0 <md:ml-4 <md:mb-14"
        :title="icons.title"
        @close="closeAboutModal"
      >
        <template #default="{ active }">
          <div
            v-for="(
              { title, description, shopLabel, materials, picture, yearLabel, label, hotspot, hotspots }, j
            ) in icons.boots[0].slides"
            :key="j"
            class="relative full center md:flex"
            :class="{ 'bg-brand-5 gap-y-8': j >= 2 }"
            :inert="j !== active"
          >
            <div class="w-full f-col md:flex-row" :class="{ 'justify-center': j >= 2 }" style="height: 90%">
              <h2
                v-if="title"
                v-html="title"
                class="m-4 title-1 md:hidden"
                :class="j === 0 ? 'mb-0 md:pb-80' : 'hidden'"
                style="padding-right: 10rem"
              />

              <div class="flex justify-center">
                <div class="relative">
                  <base-picture
                    v-if="j !== 1"
                    v-bind="picture"
                    class="inline md:w-1/2"
                    :props-img="{ class: 'max-h-full contain' }"
                  />

                  <template v-if="j === 0 && hotspot">
                    <base-button :aria-label="shopLabel" class="absolute <md:hidden" style="top: 40%; right: 25%" @click="openShop(hotspot, 'lg')">
                      <span
                        class="h-12 w-12 flex center rounded-full bg-brand-2 outline"
                        style="outline-width: .5rem; outline-color: rgba(217,217,217,0.2)"
                      >
                        <vf-icon class="c-black" name="bag" size="md" />
                      </span>
                    </base-button>

                    <base-button
                      :aria-label="shopLabel"
                      class="absolute right-0 md:hidden"
                      style="top: 40%"
                      @click="openShop(hotspot)"
                    >
                      <span
                        class="h-12 w-12 flex center rounded-full bg-brand-2 outline"
                        style="outline-width: .5rem; outline-color: rgba(217,217,217,0.2)"
                      >
                        <vf-icon class="c-black" name="bag" size="md" />
                      </span>
                    </base-button>
                  </template>
                </div>
              </div>

              <div class="mt-2 flex center md:w-1/2 <md:px-4">
                <div class="grid gap-y-8 md:max-w-2/3 md:gap-y-10">
                  <h2
                    v-if="title"
                    v-html="title"
                    class="mt-4 title-1 md:display-1"
                    :class="j === 1 ? 'pr-40 md:pb-80' : '<md:hidden'"
                  />

                  <transition name="fade">
                    <div
                      v-show="plusDisabled && j === 1"
                      class="absolute z-2 grid cols-2 w-1/2 gap-10 duration <md:hidden"
                      style="bottom: 20%"
                    >
                      <div v-for="(feature, k) in targetIcon" :key="k" class="grid cols-3 gap-4">
                        <div>
                          <base-picture v-bind="feature.picture" />
                        </div>
                        <div class="col-span-2">
                          <h4 v-html="feature.label" class="my-4 subtitle-5" />
                          <p v-html="feature.description" class="text-sm" />
                        </div>
                      </div>
                    </div>
                  </transition>

                  <h3 v-if="yearLabel" v-html="yearLabel" class="mt-4 display-2 c-black normal-case md:pt-10" />
                  <h4 v-if="label" v-html="label" class="title-3 md:text-lg" />
                  <div v-html="description" class="md:text-md" />
                  <div v-if="materials" class="grid cols-3 gap-6">
                    <div v-for="(material, k) in materials" :key="k">
                      <h4 v-html="material.title" class="mb-1 subtitle-5" />
                      <p v-html="material.description" class="text-sm" />
                    </div>
                  </div>
                </div>
              </div>

              <template v-if="j === 1 && hotspots">
                <div class="f-col center md:w-1/2">
                  <base-picture v-bind="picture" :style="rotateEvent" />

                  <transition name="fade">
                    <span v-if="!plusDisabled" class="z-2 <md:absolute" style="bottom: 15%">
                      <base-picture v-bind="pointingFinger" class="mb-5" style="margin-left: 3.8rem" />
                      <h4 class="subtitle-5">
                        {{ discoverAll }}
                      </h4>
                    </span>
                  </transition>

                  <transition name="fade">
                    <div v-if="plusDisabled" class="duration-500">
                      <base-button
                        aria-label="close"
                        class="absolute h-12 w-12 flex center rounded-full bg-black <md:left-1/2 -translate-x-1/2"
                        style="top: 70%"
                        @click="handleCloseIcon"
                      >
                        <vf-icon class="c-white" name="close" size="md" />
                      </base-button>
                      <div class="grid cols-2 m-6 gap-6 duration md:hidden">
                        <div v-for="(feature, k) in targetIcon" :key="k" class="text-center">
                          <base-picture v-bind="feature.picture" />
                          <h4 v-html="feature.label" class="my-2 subtitle-5" />
                          <span class="text-sm">{{ feature.brief }}</span>
                        </div>
                      </div>
                    </div>
                  </transition>

                  <template v-for="({ sm, md, content }, m) in hotspots" :key="m">
                    <transition name="fade">
                      <div v-if="!plusDisabled" class="duration-500">
                        <div class="absolute md:hidden" :style="`top: ${sm.top}%; right: ${sm.right}%;`">
                          <base-button
                            aria-label="plus"
                            class="h-11 w-11 flex center rounded-full bg-brand-2"
                            @click="handlePlusIcon(sm.rotationDeg, content)"
                          >
                            <vf-icon class="c-black" name="plus" size="md" />
                          </base-button>
                        </div>
                        <div class="absolute <md:hidden" :style="`top: ${md.top}%; right: ${md.right}%;`">
                          <base-button
                            aria-label="plus"
                            class="h-11 w-11 flex center rounded-full bg-brand-2"
                            @click="handlePlusIcon(md.rotationDeg, content)"
                          >
                            <vf-icon class="c-black" name="plus" size="md" />
                          </base-button>
                        </div>
                      </div>
                    </transition>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </template>
      </modal-about-us>

      <modal-about-us
        v-if="target === 'icons-02'"
        class="bg-white"
        class-button-next="right-0 md:top-1/2 absolute <md:bottom-0 <md:mb-14"
        class-button-previous="md:right-0 md:top-1/2 absolute <md:bottom-0 <md:ml-4 <md:mb-14"
        :title="icons.title"
        @close="closeAboutModal"
      >
        <template #default="{ active }">
          <div
            v-for="({ title, description, shopLabel, hotspot, materials, picture }, j) in icons.boots[1].slides"
            :key="j"
            class="full md:flex md:center"
            :class="{ 'bg-brand-5': j }"
            :inert="j !== active"
          >
            <div
              class="w-full flex p-4 <md:flex-col md:self-center md:p-10"
              :class="{ 'full between md:flex-row-reverse': j }"
              style="height: 90%"
            >
              <h2
                v-if="title"
                v-html="title"
                class="mt-4 self-start title-1 md:hidden"
                style="padding-right: 10rem"
              />

              <div class="flex justify-center" :class="{ '<md:mt-6 md:w-3/4 md:items-center': j }">
                <div v-if="!j" class="relative">
                  <base-picture v-bind="picture" :props-img="{ class: 'max-h-full contain' }" />

                  <template v-if="hotspot">
                    <base-button
                      :aria-label="shopLabel"
                      class="absolute <md:hidden"
                      style="top: 40%; right: 25%"
                      @click="openShop(hotspot, 'lg')"
                    >
                      <span
                        class="h-12 w-12 flex center rounded-full bg-brand-2 outline"
                        style="outline-width: .5rem; outline-color: rgba(217,217,217,0.2)"
                      >
                        <vf-icon class="c-black" name="bag" size="md" />
                      </span>
                    </base-button>

                    <base-button
                      :aria-label="shopLabel"
                      class="absolute right-0 md:hidden"
                      style="top: 40%"
                      @click="openShop(hotspot)"
                    >
                      <span
                        class="h-12 w-12 flex center rounded-full bg-brand-2 outline"
                        style="outline-width: .5rem; outline-color: rgba(217,217,217,0.2)"
                      >
                        <vf-icon class="c-black" name="bag" size="md" />
                      </span>
                    </base-button>
                  </template>
                </div>

                <base-picture
                  v-if="j"
                  v-bind="picture"
                  :props-img="{ class: 'max-h-full' }"
                  style="box-shadow: rgba(0, 0, 0, 0.4) 0 0 1.25rem 0; max-width: 80rem"
                  :style="j === 1 ? 'aspectRatio: 11 / 13; max-height: 90%;' : 'aspectRatio: 89 / 57;'"
                />
              </div>

              <div class="<md:px-4" :class="j > 0 ? 'md:mt-10 md:w-1/4 md:h-full flex align-start justify-center' : 'mt-2 f-col center md:w-1/2'">
                <div :class="{ 'grid gap-y-8 md:max-w-2/3 md:gap-y-10': !j }">
                  <h2 class="self-start title-1 <md:hidden" :class="{ 'mt-4': !j }">
                    {{ title }}
                  </h2>
                  <p v-if="description" class="mb-6 md:text-md">
                    {{ description }}
                  </p>

                  <template v-if="materials">
                    <div class="flex gap-16">
                      <div v-for="(material, k) in materials" :key="k" class="w-1/2" style="max-width: 8rem">
                        <p class="mb-1 subtitle-5">
                          {{ material.title }}
                        </p>
                        <p class="text-sm">
                          {{ material.description }}
                        </p>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </template>
      </modal-about-us>

      <modal-about-us
        v-if="target === 'icons-03'"
        class="bg-white"
        class-button-next="right-0 md:top-1/2 absolute <md:bottom-0 <md:mb-14"
        class-button-previous="md:right-0 md:top-1/2 absolute <md:bottom-0 <md:ml-4 <md:mb-14"
        :title="icons.title"
        @close="closeAboutModal"
      >
        <template #default="{ active }">
          <div
            v-for="({ title, description, shopLabel, hotspot, materials, picture }, j) in icons.boots[2].slides"
            :key="j"
            class="full center md:flex"
            :class="{ 'bg-brand-5': j }"
            :inert="j !== active"
          >
            <div
              class="w-full f-col p-4 md:flex-row md:self-center md:p-10"
              :class="{ 'full between md:flex-row-reverse': j }"
              style="height: 90%"
            >
              <h2 v-if="title" v-html="title" class="mt-4 self-start title-1 md:hidden" style="padding-right: 10rem" />

              <div class="flex justify-center" :class="{ '<md:mt-6 md:w-3/4 md:items-center': j }">
                <div v-if="!j" class="relative">
                  <base-picture v-bind="picture" :props-img="{ class: 'max-h-full contain' }" />
                  <template v-if="hotspot">
                    <base-button
                      :aria-label="shopLabel"
                      class="absolute <md:hidden"
                      style="top: 40%; right: 25%"
                      @click="openShop(hotspot, 'lg')"
                    >
                      <span
                        class="h-12 w-12 flex center rounded-full bg-brand-2 outline"
                        style="outline-width: .5rem; outline-color: rgba(217,217,217,0.2)"
                      >
                        <vf-icon class="c-black" name="bag" size="md" />
                      </span>
                    </base-button>

                    <base-button
                      :aria-label="shopLabel"
                      class="absolute right-0 md:hidden"
                      style="top: 40%"
                      @click="openShop(hotspot)"
                    >
                      <span
                        class="h-12 w-12 flex center rounded-full bg-brand-2 outline"
                        style="outline-width: .5rem; outline-color: rgba(217,217,217,0.2)"
                      >
                        <vf-icon class="c-black" name="bag" size="md" />
                      </span>
                    </base-button>
                  </template>
                </div>

                <base-picture
                  v-if="j"
                  v-bind="picture"
                  :props-img="{ class: 'max-h-full' }"
                  style="box-shadow: rgba(0, 0, 0, 0.4) 0 0 1.25rem 0; aspect-ratio: '89/57'; max-width: 80rem"
                />
              </div>

              <div class="<md:px-4" :class="j > 0 ? 'md:mt-10 md:w-1/4 md:h-full flex align-start justify-center' : 'mt-2 f-col center md:w-1/2'">
                <div :class="{ 'grid gap-y-8 md:max-w-2/3 md:gap-y-10': !j }">
                  <h2 class="self-start title-1 <md:hidden" :class="{ 'mt-4': !j }">
                    {{ title }}
                  </h2>
                  <p v-if="description" class="mb-6 md:text-md">
                    {{ description }}
                  </p>

                  <template v-if="materials">
                    <div class="flex" style="gap: 4rem">
                      <div v-for="(material, k) in materials" :key="k" class="w-1/2" style="max-width: 8rem">
                        <p class="mb-1 subtitle-5">
                          {{ material.title }}
                        </p>
                        <p class="text-sm">
                          {{ material.description }}
                        </p>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </template>
      </modal-about-us>
    </section>
    <cms-section v-if="eSpots?.[3]" :section="eSpots[3]" />
    <section id="our-vision" class="relative" data-scroll-el="our-vision">
      <div
        class="f-col center bg-black transition-padding duration-500 md:items-end"
        :class="{ 'md:p-8': ourVisionIsVisible }"
      >
        <vf-video
          v-bind="ourVision.video"
          aria-labelledby="our-vision-title"
          class="duration-500 md:w-full"
          :class="{ 'md:rounded-xl': ourVisionIsVisible }"
          loop
        />
        <div class="absolute c-white md:w-1/2">
          <h2 ref="ourVisionHeading" id="our-vision-title" class="display-2 <md:mb-8 md:mb-8 md:max-w-2/3 lg:display-3">
            {{ ourVision.title }}
          </h2>
          <p class="mb-8 max-w-2/3 text-md <md:hidden">
            {{ ourVision.description }}
          </p>
          <base-button class="flex center subtitle-5 <md:mx-a" @click="openAboutModal('our-vision')">
            {{ seeMore }}
            <span class="ml-4 h-10 w-10 flex center rounded-full bg-white" style="transform: rotate(270deg)">
              <vf-icon class="c-black" name="arrow" size="md" style="animation: vf-arrow-animation 2.5s linear infinite" />
            </span>
          </base-button>
        </div>
      </div>

      <transition name="fade">
        <modal-about-us
          v-if="target === 'our-vision'"
          class="bg-brand-5"
          class-button-next="right-0 top-1/2 absolute <md:hidden"
          class-button-previous="right-0 top-1/2 absolute <md:hidden"
          :title="ourVision.title"
          @close="closeAboutModal"
        >
          <template #default="{ active }">
            <div
              v-for="({ title, description, picture, video, youtube }, i) in ourVision.slides"
              :key="i"
              class="full f-col"
              :inert="i !== active"
            >
              <div class="f-col md:flex-row" style="height: 90%">
                <div>
                  <base-picture
                    v-if="picture"
                    v-bind="picture"
                    class="mt-6 inline md:w-1/2"
                    :class="{ '<md:px-4': i > 0 }"
                    :props-img="{ class: 'max-h-full contain' }"
                  />
                </div>

                <div v-if="video" class="relative mb-4 f-col center md:w-1/2 md:overflow-hidden">
                  <vf-video v-bind="video" aria-labelledby="our-vision-slides-title" class="max-h-full md:h-screen md:w-fit" loop />
                  <base-button
                    class="absolute f-col center c-white"
                    @click="ModalYoutube.open(
                      {
                        videoUrl: youtube,
                        title,
                      },
                    )"
                  >
                    <span class="mb-4 b-2 b-white rounded-full p-2">
                      <vf-icon name="play" size="2xl" />
                    </span>
                    <span class="title-3">{{ playVideo }}</span>
                  </base-button>
                </div>

                <div class="flex center md:w-1/2 <md:px-4">
                  <div class="md:max-w-2/3">
                    <h3 id="our-vision-slides-title" class="my-4 title-4 md:my-4 md:pb-10 md:display-1" :class="{ '<md:hidden': !i }">
                      {{ title }}
                    </h3>
                    <p v-html="description" class="md:text-md" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </modal-about-us>
      </transition>
    </section>
    <cms-section v-if="eSpots?.[4]" :section="eSpots[4]" />
    <section class="relative my-10 flex center">
      <vf-button
        v-for="({ name, url }, key) in links"
        :key
        :size="{ sm: 'xs', md: 'sm' }"
        :to="url"
      >
        {{ name }}
      </vf-button>
    </section>

    <modal-youtube hide-close-button size="lg" style-content="background-color: #303030" />
    <panel-hotspot-shop class-content="rounded-xl rounded-b-0" position="bottom" />
  </main>
</template>

<script lang="ts" setup>
import type { SizesSubUnion } from '#types/sizes'

const ModalYoutube = createModal('youtube')
const PanelHotspotShop = createPanel('hotspot-shop')

const activeLink = ref(0)
const atOurRoots = ref(false)
const target = ref()
const rotateEvent = ref()
const plusDisabled = ref(false)
const targetIcon = ref()
const iconsRef = ref<HTMLElement>()
const ourVisionHeading = ref<HTMLHeadingElement>()
const ourVisionIsVisible = useElementVisibility(ourVisionHeading)
const isIconsVisible = useElementVisibility(iconsRef)
const header = useHeaderStore()
const host = useHost()

const { data, error } = await useApi().internal.getStaticPage('about-us')
if (!data.value) throw createError({ ...error.value!, fatal: true })

const {
  hero,
  stickyNav,
  readLess,
  ourRoots,
  discoverMore,
  playVideo,
  cultureOfInnovation,
  icons,
  ourVision,
  seeMore,
  links,
  pointingFinger,
  discoverAll
} = data.value

const eSpots = (await useCms().getSections.generic('about-us')).data.value?.content.sections

const handleDownwardNav = (id: string, offsetHeight: number) => {
  scrollToElement(id, { offset: (offsetHeight + header.height.navigation) })
}

const handleTabNav = (id: string, offsetHeight: number) => {
  activeLink.value = offsetHeight
  scrollToElement(id, { offset: (43 + header.height.navigation) })
}

const handleOurRoots = () => {
  scrollToElement('our-roots', { offset: header.height.navigation })
  atOurRoots.value = !atOurRoots.value
}

const openAboutModal = (modalName, scrollTarget = '') => {
  scrollToElement(scrollTarget || modalName, { offset: header.height.navigation, behavior: 'instant' })
  target.value = modalName
}

const closeAboutModal = () => {
  target.value = ''
}

const canonicalUrl = `https://${host}${useLocalisedRoute('/about-us')}`
useHead({
  htmlAttrs: { class: 'motion-safe:scroll-smooth' },
  link: () => [
    { rel: 'canonical', href: canonicalUrl }
  ]
})

const handlePlusIcon = (deg, content) => {
  plusDisabled.value = true
  rotateEvent.value = `animation: vf-rotate-deg-${deg}-in .5s ease-out forwards;`
  targetIcon.value = content
}

const handleCloseIcon = () => {
  plusDisabled.value = false
  rotateEvent.value = rotateEvent.value.replace('-in', '-out')
}

const openShop = ({ title, ctas }, size: SizesSubUnion<'sm' | 'lg'> = 'lg') => PanelHotspotShop.open({ title, ctas }, { size })
</script>
